import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import Colors from '../Themes/Colors/colors.js';
import Divider from '../Atoms/Divider.js';
import Typography from '../Atoms/Typography.js';
import ItemSummaryCard from '../Molecules/ItemSummaryCard.js';
import { useTranslation } from 'react-i18next';
import QsrBillBreakupShimmer from '../Components/Cells/BillBreakup/Web/index.shimmer.js';

function QsrBillBreakup(_a) {
    var tokenNo = _a.tokenNo, items = _a.items, classes = _a.classes, loading = _a.loading;
    if (loading)
        return React__default.createElement(QsrBillBreakupShimmer, null);
    var t = useTranslation().t;
    return (React__default.createElement("div", { className: classNames('qsr-bill_breakup', classes) },
        React__default.createElement("div", { className: "qsr-bill_breakup__header" },
            React__default.createElement(Typography, { variant: "bodyTextOneMain", color: Colors.SPUN_PEARL, classes: "qsr-token-number-label" }, t('orderSuccess.orderNo')),
            React__default.createElement(Typography, { variant: "headingOne", weight: "semibold", color: Colors.BLACK, classes: "qsr-token-number" }, tokenNo)),
        React__default.createElement("div", { className: "bill_breakup__divider" },
            React__default.createElement("div", { className: "semi_cirle_right" }),
            React__default.createElement(Divider, { variant: "horizontal", classes: "divider__line", color: Colors.GREY_THREE, dividerStyle: "dashed" }),
            React__default.createElement("div", { className: "semi_circle_left" })),
        React__default.createElement("div", { className: "qsr-bill_breakup__body" }, items.map(function (item, index) { return (React__default.createElement(React__default.Fragment, { key: index },
            index !== 0 && (React__default.createElement(Divider, { variant: "horizontal", classes: "body__divider", color: Colors.GREY_FIVE, dividerStyle: "solid" })),
            React__default.createElement(ItemSummaryCard, { item_title: item.item_title, quantity: item.quantity, options: item.options }))); }))));
}

export { QsrBillBreakup as default };
//# sourceMappingURL=BillBreakup.js.map
